const GET_NEW_ARTICLES_LOADING = 'new-articles/GET_NEW_ARTICLES_LOADING';
const GET_NEW_ARTICLES_SUCCESS = 'new-articles/GET_NEW_ARTICLES_SUCCESS';
const GET_NEW_ARTICLES_ERROR = 'new-articles/GET_NEW_ARTICLES_ERROR';

export {
  GET_NEW_ARTICLES_LOADING,
  GET_NEW_ARTICLES_SUCCESS,
  GET_NEW_ARTICLES_ERROR
};
